import React from 'react';
import { motion } from 'framer-motion';
import { Check, ArrowRight, Gift, Sparkles } from 'lucide-react';
export function Upsell() {
  const benefits = ['Registro en Sunbiz paso a paso', 'Obtención de EIN sin SSN', 'Bancos recomendados para no residentes', 'Evita multas de $400 por errores comunes'];
  return <section className="py-24 bg-lavender relative overflow-hidden" id="planes" data-id="element-171">
      <div className="max-w-7xl mx-auto px-6" data-id="element-172">
        <div className="bg-gradient-to-br from-white to-lavender-soft rounded-[2.5rem] p-8 md:p-12 lg:p-16 shadow-soft border border-white/50 relative overflow-hidden" data-id="element-173">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-accent/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-174" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent-light/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/3" data-id="element-175" />

          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center relative z-10" data-id="element-176">
            {/* Left Column: Visual / Book */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="relative flex justify-center" data-id="element-177">
              <img src="https://cdn.magicpatterns.com/uploads/aSqKuFYZToAM3XXedoEZms/ChatGPT_Image_May_27,_2026,_12_03_26_PM1.png" alt="Guía Digital Ruta USA 360 — Crea tu empresa en Florida" className="w-full max-w-md drop-shadow-2xl rounded-lg" data-id="element-178" />
            </motion.div>

            {/* Right Column: Offer Details */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} data-id="element-179">
              <div className="inline-block px-4 py-1.5 rounded-full bg-accent/10 text-accent font-bold text-sm tracking-wide uppercase mb-6" data-id="element-180">
                Ruta USA 360 · Edición Florida
              </div>

              <h2 className="font-serif text-4xl md:text-5xl font-bold text-ink leading-tight mb-6" data-id="element-181">
                Aprende a crear tu empresa en Florida{' '}
                <em className="italic text-accent-light" data-id="element-182">paso a paso</em>
              </h2>

              <p className="text-lg text-ink/70 mb-8" data-id="element-183">
                La guía definitiva con checklist, requisitos reales y errores
                que debes evitar para crear tu empresa en Florida correctamente.
              </p>

              <ul className="space-y-4 mb-8" data-id="element-184">
                {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-185">
                    <div className="mt-1 bg-accent/10 p-1 rounded-full" data-id="element-186">
                      <Check className="w-4 h-4 text-accent" strokeWidth={3} data-id="element-187" />
                    </div>
                    <span className="text-ink font-medium" data-id="element-188">{benefit}</span>
                  </li>)}
              </ul>

              {/* Bonus block — secondary visual hierarchy */}
              <div className="relative bg-lavender-soft/70 border border-accent/15 rounded-2xl p-4 mb-10 flex items-start gap-3" data-id="element-189">
                <div className="bg-white p-2 rounded-full shadow-sm flex-shrink-0" data-id="element-190">
                  <Gift className="w-4 h-4 text-accent" data-id="element-191" />
                </div>
                <div data-id="element-192">
                  <div className="inline-flex items-center gap-1.5 mb-0.5" data-id="element-193">
                    <Sparkles className="w-3 h-3 text-accent" data-id="element-194" />
                    <span className="text-[11px] font-bold tracking-wider uppercase text-accent" data-id="element-195">
                      Bonus incluido
                    </span>
                  </div>
                  <p className="text-ink/80 text-sm font-medium leading-snug" data-id="element-196">
                    Plantillas de Operating Agreement incluidas como recurso
                    adicional.
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-3xl p-6 shadow-sm border border-ink/5 flex flex-col sm:flex-row items-center justify-between gap-6" data-id="element-197">
                <div data-id="element-198">
                  <p className="text-sm text-ink/50 font-medium line-through mb-1" data-id="element-199">
                    Precio regular $67
                  </p>
                  <div className="flex items-baseline gap-2" data-id="element-200">
                    <span className="text-4xl font-bold text-ink" data-id="element-201">$27.99</span>
                    <span className="text-ink/60 font-medium" data-id="element-202">USD</span>
                  </div>
                </div>

                <a href="https://inkovacreation.store/shop/0de4a31b-dafb-4911-b0f5-64f146eb7e48" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto group bg-accent hover:bg-ink text-white px-6 py-3 rounded-full font-semibold text-sm transition-all shadow-md hover:shadow-xl inline-flex items-center justify-center text-center gap-2" data-id="element-203">
                  Comprar ahora
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-204" />
                </a>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}